import {Link as PrimerLink} from '@primer/react'
import type {ReactNode} from 'react'
import {Link} from '@github-ui/react-router'
import {routeToReviewSummary, useCurrentPathParams} from '../../../overview/data/use-comments-routing'

export function PullRequestReviewAction({
  reviewId,
  commentCount,
  children,
}: {
  reviewId: bigint
  commentCount: number
  children: ReactNode
}) {
  const pathParams = useCurrentPathParams()

  return (
    <PrimerLink
      as={Link}
      to={routeToReviewSummary(pathParams, reviewId.toString())}
      inline
      className="fgColor-default text-semibold"
    >
      {children}{' '}
      <span className="fgColor-muted">{`(${commentCount} ${commentCount === 1 ? 'comment' : 'comments'})`}</span>
    </PrimerLink>
  )
}
